import React, { useEffect, useState } from "react";
import { Button, Col, Row, Table ,Form} from "react-bootstrap";
import trasportApi from "../../api/trasportApi";
import { ShimmerTable } from "react-shimmer-effects";
import Main from "../layout/Main";
import StateEdit from "./StateEdit";
import Confirm from '../Confirm';
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { Link } from "react-router-dom";
import InfoPill from "../InfoPill";
import Helmet from "react-helmet";
import { LIST_TAB_TITLE } from "../../constants/CONSTANT";

// React Icons Starts Here
import { FiEdit } from "react-icons/fi";
import { FaTrashAlt } from "react-icons/fa";
import { BsChevronRight } from "react-icons/bs";
//React Icons Ends here.


const SubjectList = () => {
  const [body, setBody] = useState([]);
  const [modalShow, setModalShow] = React.useState(false);
  const [driverRec, setBranch] = React.useState({});
  const [modalShowEditBranch, setModalShowEditBranch] = React.useState(false);
  
  useEffect(() => {
    fetchAllBranches();
  }, []);

  const fetchAllBranches = () => {
    async function init() {
      const branch = await trasportApi.fetchAllStates();
      if (branch) {
        setBody(branch);
      } else {
        setBody([]);
      }
    }
    init();
  }

 

  // Create table headers consisting of 4 columns.
  const header = [
    { title: "Country", prop: "country_name", isFilterable: true },
    { title: "State", prop: "state_name", isFilterable: true },
      
  ];
  
    header.push({
      title: "Actions",
      prop: "id",
      cell: (row) => (
        <div>
          <Button className='btn-sm mx-2' onClick={() => editFinancialYearList(row)}><FiEdit /></Button>
          <Button variant="danger" className='btn-sm mx-2' onClick={() => handleDelete(row)}><FaTrashAlt/></Button>
        </div>
      ),
    });


  // Randomize data of the table columns.
  // Note that the fields are all using the `prop` field of the headers.
  const labels = {
    beforeSelect: " ",
  };

  const createBranch = () => {
    setBranch({});
    setModalShowEditBranch(true);
  };

  const submitFinancialYearList = () => {
    // setModalShowCreateDoctorDuty(false);
    // setModalShowEditBranch(false);
    // fetchAllDuties();
    // setDoctorDuty({});
  }

  const editFinancialYearList = (row) => {
    setModalShowEditBranch(true);
    setBranch(row);
  }

  const handleDelete = (row) => {
    console.log(row);
    setModalShow(true);
    setBranch(row);
  }
  const isdelete = async () => {    
    const result = await trasportApi.deleteState(driverRec.id);
    if (result.success) {
      setBranch('');
      setModalShow(false);
      fetchAllBranches();
    }
  }
  
  return (
    <Main>
      <>
        <Helmet>
          <title>{LIST_TAB_TITLE.StateList}</title>
        </Helmet>
      </>

      {modalShowEditBranch &&
        <StateEdit
          show={modalShowEditBranch}
          onHide={() => setModalShowEditBranch(false)}
          submitFinancialYearList={submitFinancialYearList}
          driverRec={driverRec ? driverRec : {}}
        />
      }

      {modalShow &&
        <Confirm
          show={modalShow}
          onHide={() => setModalShow(false)}
          isdelete={isdelete}
          title="Confirm delete?"
          message="You are going to delete the record. Are you sure?"
          table="Driver"
        />}

      <Row className="g-0">
        <Col lg={2} className="mx-2">
          <Link to="/home" style={{ "text-decoration": "none" }}>
            Home
          </Link>
          {/* <i className="fa-solid fa-chevron-right"></i>  */}
          <BsChevronRight/>
          State List
        </Col>
        <Col lg={12} className="p-lg-4">
          {body ? (
            <DatatableWrapper
              body={body}
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 10,
                  options: [5, 10, 15, 20],
                },
              }}
            >
              <Row className="mb-4">
                <Col
                  xs={12}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Filter />
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  lg={4}
                  className="d-flex flex-col justify-content-start align-items-center"
                >
                  <PaginationOptions labels={labels} />
                  <InfoPill left="Total" right={body?.length} />
                
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Button
                    className="btn-md"
                    variant="primary"
                    onClick={() => createBranch(true)}
                  >
                    New State
                  </Button>
                </Col>
              </Row>

              <Table striped className="data-table">
                <TableHeader />

                <TableBody />
              </Table>

              <Pagination />
            </DatatableWrapper>
          ) : (
            <ShimmerTable row={10} col={8} />
          )}
        </Col>
        <Col lg={2}></Col>
      </Row>
    </Main>
  );
};
export default SubjectList;
